export const sessionStorage = window.sessionStorage
sessionStorage.clear = () => {
  // When clearing we don't want to remove the address where we should go after login
  const address = sessionStorage.getItem('ZervantGoToAddress')
  while (sessionStorage.length > 0) {
    sessionStorage.removeItem(sessionStorage.key(0))
  }
  if (address) {
    sessionStorage.setItem('ZervantGoToAddress', address)
  }
}
export const localStorage = window.localStorage
export const getLocation = (): Location => window.location
export const open = window.open
export const initialConfiguration = window.initialConfiguration
export const Stripe = window.Stripe
